/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const courseApi = platform.learningPanel.CourseAPIs;
const cerfificateApi = platform.learningPanel.CertificateAPI;
export const getCourseData = 'course-data';
export const getCourseCertificate = 'course-certificate';

export const useGetCourseData = (courseUuid: string, token: string) => {
    return useQuery([getCourseData, courseUuid], () => courseApi.getCourse(courseUuid, token), {
        enabled: Boolean(courseUuid) && Boolean(token)
    });
};

export const useGetCourseCertificate = (courseUuid: string, userUuid: string) => {
    return useQuery(
        [getCourseCertificate, courseUuid, userUuid],
        () => cerfificateApi.getCourseCertificate(courseUuid),
        {
            enabled: Boolean(courseUuid) && Boolean(userUuid)
        }
    );
};
